import Axios from 'axios';
import i18n from 'i18next';
import { v4 as uuidv4 } from 'uuid';

// components
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PrivateRoute, AuthProvider } from './auth';
import { View } from 'components/lib';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { initReactI18next } from 'react-i18next';
import TagManager from 'react-gtm-module';
import GTMPageView from 'components/global/GTMView/GTMView';

// locales
import English from 'locales/en/index';
import Spanish from 'locales/es/index';
import Turkish from 'locales/tr/index';

// 404
import { NotFound } from 'views/error/404';

//403
import { NoPermission } from 'views/error/403';

//500
import { InternalError } from 'views/error/500';

//502
import { GatewayError } from 'views/error/502';

// tailwind css
import '../css/output.css';

// settings
const Settings = require('settings.json');
const StripePromise = loadStripe(Settings[process.env.NODE_ENV].stripe.publishableAPIKey);

// Google Tag Manager
const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_TAG,
};

TagManager.initialize(tagManagerArgs);

const routes = [
    ...require('routes/account').default,
    ...require('routes/app').default,
    ...require('routes/auth').default,
    ...require('routes/website').default,
    ...require('routes/topos').default,
    ...require('routes/labs').default,
    ...require('routes/streams').default,
    ...require('routes/lpath').default,
    ...require('routes/project').default,
    ...require('routes/hiring').default,
    ...require('routes/lms').default,
    ...require('routes/quiz').default,
    ...require('routes/internships').default,
]


export default function App(props) {
    const user = JSON.parse(localStorage.getItem('user'));
    Axios.defaults.baseURL = Settings[process.env.NODE_ENV].server_url;

    let deviceId = localStorage.getItem('deviceId');
    if (!deviceId) {
        deviceId = uuidv4();
        localStorage.setItem("deviceId", deviceId)
    };

    Axios.defaults.headers.common['X-Device-Id'] = deviceId;

    if (user?.token) {

        // add auth token to api header calls
        Axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token;
        Axios.defaults.headers.common['Accept-Language'] = user.locale;
    }

    i18n.use(initReactI18next).init({

        resources: {
            en: English,
            es: Spanish,
            tr: Turkish
        },
        lng: user?.locale,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        }
    });
    // render the routes
    return (
        <Elements stripe={StripePromise}>
            <AuthProvider>
                <BrowserRouter>
                    <GTMPageView />
                    <Routes>
                        {routes.map(route => {

                            return (
                                <Route
                                    key={route.path}
                                    path={route.path}
                                    element={

                                        route.permission ?
                                            <PrivateRoute permission={route.permission}>
                                                <View display={route.view} navBar={route?.show_nav} layout={route.layout} mobile={route?.mobile} title={route.title} hideNavItems={route?.hideNavItems} />
                                            </PrivateRoute> :
                                            <View display={route.view} navBar={route?.show_nav} mobile={route?.mobile} layout={route.layout} title={route.title} hideNavItems={route?.hideNavItems} />

                                    }
                                />
                            )
                        })}

                        { /* 404 */}
                        <Route path='/oops' element={<View display={InternalError} layout='home' title={"500 Internal Error"} />} />
                        <Route path='/nopermission' element={<View display={NoPermission} layout='home' title={"403 Unauthorized"} />} />
                        <Route path='*' element={<View display={NotFound} layout='home' title={"404 Not Found"} />} />
                        <Route path='/badgateway' element={<View display={GatewayError} layout='home' title={"502 Bad Gateway Error"} />} />

                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </Elements>
    );
}
